import { useContext } from 'react';

import type { LoggedInUser } from '../../auth/types';
import { UserContext } from '../../auth/user-provider';

export const useAtlassianUser = (): LoggedInUser => {
	const context = useContext(UserContext);

	if (!context) {
		throw new Error('useAtlassianUser must be used within UserProvider');
	}

	return context.identity;
};

export const useAtlassianUserContext = (): {
	identity: LoggedInUser;
	loading: boolean;
	error: boolean;
	handleAuthFailure: () => Promise<void>;
} => {
	const context = useContext(UserContext);

	if (!context) {
		throw new Error('useAtlassianUserContext must be used within UserProvider');
	}

	return context;
};
